import { render, staticRenderFns } from "./checkDetail.vue?vue&type=template&id=15f09346&"
import script from "./checkDetail.vue?vue&type=script&lang=js&"
export * from "./checkDetail.vue?vue&type=script&lang=js&"
import style0 from "./checkDetail.vue?vue&type=style&index=0&id=15f09346&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports